




















































































import { defineComponent } from '@vue/composition-api';
import ViewContainer from '../components/ViewContainer.vue';

export default defineComponent({
  name: 'PrivacyPolicy',
  components: {
    ViewContainer,
  },
  setup(props, ctx) {
    const lastUpdated = 'February 16, 2026';

    function openCookieSettings(): void {
      ctx.root.$root.$emit('open-cookie-settings');
      // No need to go back, the banner will appear over this page
    }

    return {
      lastUpdated,
      openCookieSettings,
    };
  },
});
